import { Link } from "gatsby";
import React from "react";

const Nav = () => (
  <nav>
    <ul>
      <li>
        <Link activeClassName="active-link" to="/">
          Inicio
        </Link>
      </li>
      <li>
        <Link activeClassName="active-link" to="/blog/" partiallyActive={true}>
          Blog
        </Link>
      </li>
      <li>
        <Link activeClassName="active-link" to="/tags/" partiallyActive={true}>
          Temas
        </Link>
      </li>
    </ul>
  </nav>
);

export default Nav;
